import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import WS10Theme from '@uk-source-web/theme-ws10';
import { AmigoTheme } from '@vf-theme-repo/theme-amigo';

import { MarketSegmentEnum } from '@vfmfe/foundations';
import { getMarketSegment } from '../../utils';

const theme = getMarketSegment() === MarketSegmentEnum.AMIGO ? AmigoTheme : WS10Theme;

theme.setBaseAssetLocation?.(
    getMarketSegment() === MarketSegmentEnum.AMIGO
        ? 'https://www.oteuamigo.pt/content/dam/digital-white/'
        : 'https://oneportal.vodafone.com/cdn/project/source-web/'
);
/**
* This function is responsible for returning the theme wrapper base based on the market segment.
* @returns a JSX element with styled component wrapping the children
*/
export default function ThemeProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
    const { globalStyles: GlobalStyles } = WS10Theme;

    return (
        <StyledThemeProvider theme={theme}>
            {GlobalStyles && <GlobalStyles />}
            {children}
        </StyledThemeProvider>
    );
}
